import { FormGroup } from '@angular/forms';
import { ApplianceDetailsAdditionalAppliancesForm } from './appliance-details-additional-appliances-form.interface';

export type ApplianceDetailsAdditionalAppliancesFormValue = ReturnType<
  FormGroup<ApplianceDetailsAdditionalAppliancesForm>['getRawValue']
>;
